<template>
  <div class="default-modal order-details-modal">
    <div class="default-modal__header order-details-modal__header">
      <h3 class="default-modal__title order-details-modal__title">Детали заказа № {{ order.id }}</h3>
      <button type="button" class="default-modal__close order-details-modal__close" @click="$emit('close')">
        <IconComponent name="close" class="default-modal__close-icon" />
      </button>
    </div>
    <div class="default-modal__body order-details-modal__body">
      <div class="order-details-modal__content">
        <!-- Информация о заказе -->
        <div class="order-details-modal__info">
          <div class="order-details-modal__info-grid">
            <div class="order-details-modal__info-item">
              <span class="order-details-modal__info-label">Дата заказа:</span>
              <span class="order-details-modal__info-value">
                {{ order.created_at | formatDate("DD.MM.YYYY HH:mm") }}
              </span>
            </div>
            <!--            <div v-if="order.purchased_at" class="order-details-modal__info-item">-->
            <!--              <span class="order-details-modal__info-label">Дата покупки:</span>-->
            <!--              <span class="order-details-modal__info-value">{{ order.purchased_at | formatDate }}</span>-->
            <!--            </div>-->
            <div class="order-details-modal__info-item">
              <span class="order-details-modal__info-label">Статус:</span>
              <span class="order-details-modal__info-value">{{ order.status.name }}</span>
            </div>
            <div v-if="order.delivery" class="order-details-modal__info-item">
              <span class="order-details-modal__info-label">Доставка:</span>
              <span class="order-details-modal__info-value">{{ order.delivery.title }}</span>
            </div>
            <div v-if="order.delivery && order.delivery.time_delivery" class="order-details-modal__info-item">
              <span class="order-details-modal__info-label">Срок доставки:</span>
              <span class="order-details-modal__info-value">{{ order.delivery.time_delivery }}</span>
            </div>
            <div class="order-details-modal__info-item">
              <span class="order-details-modal__info-label">Тип получения:</span>
              <span class="order-details-modal__info-value">{{ deliveryTypeLabel }}</span>
            </div>
          </div>

          <!-- Контактная информация -->
          <div class="order-details-modal__contact">
            <h4 class="order-details-modal__section-title">Контактная информация</h4>
            <div class="order-details-modal__contact-grid">
              <div v-if="getFullName" class="order-details-modal__info-item">
                <span class="order-details-modal__info-label">ФИО:</span>
                <span class="order-details-modal__info-value">{{ getFullName }}</span>
              </div>
              <div v-if="order.phone" class="order-details-modal__info-item">
                <span class="order-details-modal__info-label">Телефон:</span>
                <span class="order-details-modal__info-value">{{ order.phone }}</span>
              </div>
              <div v-if="order.email" class="order-details-modal__info-item">
                <span class="order-details-modal__info-label">Email:</span>
                <span class="order-details-modal__info-value">{{ order.email }}</span>
              </div>
              <div v-if="order.address && !isCdekOrder && !isCustomDelivery" class="order-details-modal__info-item">
                <span class="order-details-modal__info-label">Адрес:</span>
                <span class="order-details-modal__info-value">{{ order.address }}</span>
              </div>
              <div v-if="order.commentary" class="order-details-modal__info-item">
                <span class="order-details-modal__info-label">Комментарий:</span>
                <span class="order-details-modal__info-value">{{ order.commentary }}</span>
              </div>
              <!-- CDEK доставка -->
              <template v-if="isCdekOrder">
                <div v-if="order.cdek_pvz_address" class="order-details-modal__info-item">
                  <span class="order-details-modal__info-label">{{ order.cdek_sub_type === 'pvz' ? 'Пункт выдачи:' : 'Адрес доставки:' }}</span>
                  <span class="order-details-modal__info-value">{{ order.cdek_pvz_address }}</span>
                </div>
                <div v-if="order.cdek_tracking_number" class="order-details-modal__info-item">
                  <span class="order-details-modal__info-label">Трек-номер CDEK:</span>
                  <span class="order-details-modal__info-value">
                    <a
                      :href="'https://www.cdek.ru/ru/tracking/?order_id=' + order.cdek_tracking_number"
                      target="_blank"
                      rel="noopener"
                    >{{ order.cdek_tracking_number }}</a>
                  </span>
                </div>
              </template>
              <!-- Свой вариант доставки -->
              <template v-if="isCustomDelivery">
                <div v-if="order.delivery_custom_comment" class="order-details-modal__info-item">
                  <span class="order-details-modal__info-label">Комментарий к доставке:</span>
                  <span class="order-details-modal__info-value">{{ order.delivery_custom_comment }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- Товары в заказе -->
        <div class="order-details-modal__products">
          <h4 class="order-details-modal__section-title">Товары в заказе</h4>
          <div class="order-details-modal__products-table">
            <table class="table">
              <thead>
                <tr>
                  <th>Фото</th>
                  <th>Название</th>
                  <th class="align-right">Стоимость</th>
                  <th class="align-center">Количество</th>
                  <th class="align-right">Сумма</th>
                </tr>
              </thead>
              <tbody>
                <tr class="cart-item" v-for="(entity, i) in order.items" :key="i">
                  <td>
                    <router-link
                      v-if="entity.item"
                      :to="{
                        name: 'product',
                        params: {
                          id: entity.item.parent_id || entity.item.id,
                          link: entity.item.link,
                        },
                        query: {
                          set_id: entity.item.parent_id ? entity.item.id : undefined,
                        },
                      }"
                    >
                      <ImgComponent
                        class="cart-item__img"
                        :head_img="entity.item | item_img"
                        width="100"
                        height="100"
                      />
                    </router-link>
                  </td>
                  <td class="cart-item__title text-wrap">
                    <router-link
                      v-if="entity.item"
                      :to="{
                        name: 'product',
                        params: {
                          id: entity.item.parent_id || entity.item.id,
                          link: entity.item.link,
                        },
                        query: {
                          set_id: entity.item.parent_id ? entity.item.id : undefined,
                        },
                      }"
                    >
                      {{ entity.item.title }}
                    </router-link>
                    <div v-if="hasVariations(entity.item)" class="cart-item__variations">
                      <span v-if="entity.item.variation_one" class="cart-item__variation">
                        {{ entity.item.variation_one.attribute.title }}:
                        {{ entity.item.variation_one.value.value }}
                      </span>
                      <span v-if="entity.item.variation_two" class="cart-item__variation">
                        {{ entity.item.variation_two.attribute.title }}:
                        {{ entity.item.variation_two.value.value }}
                      </span>
                      <span v-if="entity.item.variation_three" class="cart-item__variation">
                        {{ entity.item.variation_three.attribute.title }}:
                        {{ entity.item.variation_three.value.value }}
                      </span>
                    </div>
                  </td>
                  <td class="align-right">
                    <span
                      v-if="isDiscounted(entity)"
                      class="cart-item__price cart-item__price--original"
                    >
                      {{ entity.item.price | formatPrice }}
                    </span>
                    <span class="cart-item__price" :class="{ 'cart-item__price--discounted': isDiscounted(entity) }">
                      {{ (entity.sum / entity.count) | formatPrice }}
                    </span>
                  </td>
                  <td class="align-center">
                    <span class="cart-item__count-value">{{ entity.count }}</span>
                  </td>
                  <td class="align-right">
                    <span class="cart-item__sum">
                      {{ entity.sum | formatPrice }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Кнопка повторной оплаты -->
        <div v-if="isAwaitingPayment" class="order-details-modal__repeat-payment">
          <p class="order-details-modal__repeat-payment-text">
            Заказ ожидает оплаты. Вы можете перейти на страницу оплаты.
          </p>
          <button
            class="btn btn--md btn--gray order-details-modal__repeat-payment-btn"
            :disabled="paymentLoading"
            @click="repeatPayment"
          >
            {{ paymentLoading ? 'Загрузка...' : 'Перейти к оплате' }}
          </button>
          <p v-if="paymentError" class="order-details-modal__repeat-payment-error">{{ paymentError }}</p>
        </div>

        <!-- Итоговая информация -->
        <div class="order-details-modal__total">
          <div class="order-details-modal__total-grid">
            <div v-if="hasDiscount" class="order-details-modal__total-row">
              <span class="order-details-modal__total-label">Стоимость без скидки:</span>
              <span class="order-details-modal__total-value cart-item__price--original">
                {{ originalTotal | formatPrice }}
              </span>
            </div>
            <div v-if="hasDiscount" class="order-details-modal__total-row">
              <span class="order-details-modal__total-label">Скидка:</span>
              <span class="order-details-modal__total-value order-details-modal__total-value--bonus">
                -{{ (originalTotal - parseFloat(order.sum)) | formatPrice }}
              </span>
            </div>
            <div v-if="order.bonuses_applied" class="order-details-modal__total-row">
              <span class="order-details-modal__total-label">Списано бонусов:</span>
              <span class="order-details-modal__total-value order-details-modal__total-value--bonus">
                -{{ order.bonuses_applied | formatPrice }}
              </span>
            </div>
            <div v-if="order.bonuses_earned" class="order-details-modal__total-row">
              <span class="order-details-modal__total-label">Начислено бонусов:</span>
              <span class="order-details-modal__total-value order-details-modal__total-value--earned">
                +{{ order.bonuses_earned | formatPrice }}
              </span>
            </div>
            <div class="order-details-modal__total-row order-details-modal__total-row--main">
              <span class="order-details-modal__total-label">Итого к оплате:</span>
              <span class="order-details-modal__total-value order-details-modal__total-value--main">
                {{ payableAmount | formatPrice }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import ImgComponent from "components/ImgComponent.vue";
import OrderRepeatPayment from "@/graphql/mutations/OrderRepeatPayment.graphql";

export default {
  name: "OrderDetailsModal",
  components: {
    IconComponent,
    ImgComponent,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentLoading: false,
      paymentError: null,
    };
  },
  computed: {
    getFullName() {
      return [this.order.surname, this.order.name, this.order.patronymic].filter((a) => a).join(" ");
    },
    typeCode() {
      return this.order.delivery_type && Number(this.order.delivery_type.code);
    },
    isCdekOrder() {
      return this.typeCode === 5;
    },
    isCustomDelivery() {
      return this.typeCode === 6;
    },
    deliveryTypeLabel() {
      if (this.isCdekOrder) {
        return this.order.cdek_sub_type === "pvz" ? "CDEK — Пункт выдачи" : "CDEK — Курьерская";
      }
      if (this.isCustomDelivery) return "Свой вариант";
      if (this.order.delivery && this.order.delivery.title) return this.order.delivery.title;
      if (this.order.delivery_type && this.order.delivery_type.name) return this.order.delivery_type.name;
      return "—";
    },
    isAwaitingPayment() {
      return this.order.status && this.order.status.code === 1;
    },
    payableAmount() {
      return parseFloat(this.order.sum) - (this.order.bonuses_applied || 0);
    },
    originalTotal() {
      return (this.order.items || []).reduce((acc, entity) => {
        return acc + (entity.item ? entity.item.price * entity.count : 0);
      }, 0);
    },
    hasDiscount() {
      return this.originalTotal - parseFloat(this.order.sum) > 0.01;
    },
  },
  methods: {
    isDiscounted(entity) {
      if (!entity.item) return false;
      const originalPrice = entity.item.price;
      const appliedPrice = entity.sum / entity.count;
      return originalPrice - appliedPrice > 0.01;
    },
    hasVariations(item) {
      return item.variation_one || item.variation_two || item.variation_three;
    },
    async repeatPayment() {
      this.paymentLoading = true;
      this.paymentError = null;
      try {
        const { data } = await this.$apollo.mutate({
          mutation: OrderRepeatPayment,
          variables: { order_id: this.order.id },
          context: {
            headers: { Authorization: "Bearer " + this.$store.state.apollo_token },
          },
        });
        const result = data && data.OrderRepeatPayment;
        if (result && result.payment_url) {
          let link = document.createElement("a");
          link.href = result.payment_url;
          link.click();
        } else {
          this.paymentError = (result && result.message) || "Не удалось получить ссылку на оплату";
        }
      } catch (e) {
        this.paymentError = "Ошибка: " + e.message;
      } finally {
        this.paymentLoading = false;
      }
    },
  },
};
</script>

<style lang="stylus">
.order-details-modal {
  padding: 40px;
  width: 100vw;
  max-width: 1200px;
  background: var(--white);
  border-radius: var(--main_radius);
  +below(768px) {
    padding: 30px 20px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
		padding: 0
    padding-bottom: 10px;
    border-bottom: 1px solid var(--gray);
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--main-color);

    +below(560px) {
      font-size: 1.25rem;
    }
  }

  &__close {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      width: 24px;
      height: 24px;
      transform: rotate(45deg);
    }
  }

  &__body {
    padding: 30px 0 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 30px;
		width: 100%
  }

  &__section-title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 15px;
    color: var(--main-color);
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
    +below(560px) {
      grid-template-columns: 1fr;
    }
  }

  &__contact {
    padding-top: 20px;
    border-top: 1px solid var(--gray_o5);
  }

  &__contact-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  &__info-item {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  &__info-label {
    font-size: 0.875rem;
    color: var(--main-color-75);
    font-weight: 500;
  }

  &__info-value {
    font-size: 1rem;
    color: var(--main-color);
    word-break: break-word;
  }

  &__products {
    padding-top: 20px;
    border-top: 1px solid var(--gray_o5);
  }

  &__products-table {
    overflow-x: auto;

    .table {
      width: 100%;
      border-collapse: collapse;

      thead {
        background: var(--gray_o3);

        th {
          padding: 12px 15px;
          font-weight: 600;
          font-size: 0.875rem;
          color: var(--main-color);
          white-space: nowrap;
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid var(--gray_o5);

          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 15px;
            vertical-align: middle;
          }
        }
      }
    }

    .cart-item {
      &__img {
        width: 60px;
        height: 60px;
        object-fit: contain;
        object-position: center;
        display: block;
      }

      &__title {
        min-width: 250px;
        font-size: 0.9375rem;
        color: var(--main-color);

        a {
          color: var(--main-color);
          text-decoration: none;

          &:hover {
            color: var(--main-color);
            text-decoration: underline;
          }
        }
      }

      &__variations {
        display: flex;
        flex-direction: column;
        gap: 3px;
        margin-top: 8px;
      }

      &__variation {
        font-size: 0.8125rem;
        color: var(--main-color-75);
      }

      &__price {
        font-size: 0.9375rem;
        font-weight: 600;
        color: var(--main-color);
        white-space: nowrap;

        &--original {
          text-decoration: line-through;
          color: var(--main-color-50, #aaa);
          font-weight: 400;
          font-size: 0.8125rem;
          display: block;
        }

        &--discounted {
          color: var(--red, #e53935);
        }
      }

      &__count-value {
        font-size: 0.9375rem;
        font-weight: 500;
        color: var(--main-color);
      }

      &__sum {
        font-size: 1rem;
        font-weight: 700;
        color: var(--main-color);
        white-space: nowrap;
      }
    }

    .align-right {
      text-align: right;
    }

    .align-center {
      text-align: center;
    }

    .text-wrap {
      word-wrap: break-word;
      word-break: break-word;
    }
  }

  &__repeat-payment {
    padding: 20px;
    background: var(--gray_o5, #f5f5f5);
    border-radius: var(--main_radius, 8px);
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__repeat-payment-text {
    margin: 0;
    font-size: 0.9375rem;
    color: var(--main-color);
  }

  &__repeat-payment-btn {
    align-self: flex-start;
  }

  &__repeat-payment-error {
    margin: 0;
    color: var(--red, #e53935);
    font-size: 0.875rem;
  }

  &__total {
    padding-top: 20px;
    border-top: 2px solid var(--gray);
  }

  &__total-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
  }

  &__total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
		width: 100%
		padding-bottom 10px
		border-bottom: 1px solid var(--gray_o5);

		&:last-of-type {
			border-bottom: none
		}
  }

  &__total-label {
    font-size: 1rem;
    font-weight: 500;
    color: var(--main-color);
  }

  .cart-item__price--original {
    text-decoration: line-through;
    color: var(--main-color-50, #aaa);
    font-weight: 400;
    font-size: 0.875rem;
  }

  &__total-value {
    font-size: 1rem;
    font-weight: 600;
    color: var(--main-color);

    &--bonus {
      color: var(--red);
    }

    &--earned {
      color: #10b981;
    }

    &--main {
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--main-color);
    }
  }
}
</style>
